/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { asyncConnect } from 'redux-connect';
import Tagging from '../../../../components/Tagging';
import PredeterminedListsWeb from './components/PredeterminedListsWeb';
import PredeterminedListsWap from './components/PredeterminedListsWap';
import * as labelsActions from '../../../../components/labels/actions';
import * as predeterminedListsActions from './actions';
import commonUtil from '../../../../utils/commonUtil';
import AppEvents from '../../../App/AppEvents';

const channel = commonUtil.getChannel();

const { isLablesLoaded, loadLables } = labelsActions;
const { getpredeterminedLandingPage,
  getaddPredeterminedItem,
      } = predeterminedListsActions;

@asyncConnect([{
  deferred: false,
  promise: ({ store: { dispatch, getState } }) => {
    if (!isLablesLoaded(getState())) {
      return dispatch(loadLables());
    }
    return undefined;
  },
},
])

@connect(store => ({
  lables: store.labels.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
}),
  {
    ...labelsActions,
    ...predeterminedListsActions,
  })
class PredeterminedLists extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
    this.eventId = (this.props.params && this.props.params.eventID) ? this.props.params.eventID : '';
    this.eventType = (this.props.params && this.props.params.eventType) ? this.props.params.eventType : '';
    this.wapBackButtonEvent = null;
    this.changeComponentOnBackButtonClick = this.changeComponentOnBackButtonClick.bind(this);
  }

  UNSAFE_componentWillMount() {
    this.props.getpredeterminedLandingPage(this.eventType);
  }
  componentDidMount() {
    this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);

    if (this.wapBackButtonEvent) {
      AppEvents.publish(this.wapBackButtonEvent, [this.changeComponentOnBackButtonClick]);
    }
    const eventUrl = 'gestiondeeventos/listaspredeterminadas/';

    // eslint-disable-next-line no-undef
    dataLayer.push({
      event: 'vPageView',
      GroupOne: eventUrl,
      actURL: window.location.pathname,
      actPageTitle: document.title,
      cdSection: 'Listas predeterminadas',
      Site: 'Mesa de Regalos',
      idMesa: this.props.eventId,
    });
  }


  componentWillReceiveProps(nextProps) {
    if (nextProps.addPredeterminedItemButton && nextProps.addPredeterminedItemButton.predeterminedItemInfo && nextProps.addPredeterminedItemButton.predeterminedItemInfo.length >= 0) {
      // browserHistory.push('/SearchResult');
    }
  }
  // By OD commented
  /* getTaggingData = (repositoryId, eventId) => {
    const _dataLayer = {};
    _dataLayer.event = 'addPredeterminedLists';
    _dataLayer.category = 'addPredeterminedLists';
    const _addPredeterminedLists = {};
    _addPredeterminedLists.repositoryId = repositoryId;
    _addPredeterminedLists.eventId = eventId;
    _dataLayer.addPredeterminedLists = _addPredeterminedLists;

    return _dataLayer;
  } */

  handleAddListToMyList = (repoId,deliveryMode) => {
    this.props.getaddPredeterminedItem(repoId, this.eventId,deliveryMode);
    // By OD commented
    // const repositoryId = repoId;
    // const eventId = this.eventId;
    // const _dataLayer = this.getTaggingData(repositoryId, eventId);
    // this.tagging.applyGTM('addPredeterminedLists', _dataLayer);
  }
  changeComponentOnBackButtonClick = () => {
    window.history.back();
  }

  render() {
    const addPredeterminedItemInfo = this.props.addPredeterminedItemButton ? this.props.addPredeterminedItemButton.predeterminedItemInfo : null;
    if (this.props.predeterminedLanding && this.props.predeterminedLanding.predeterminedItemInfo && this.props.predeterminedLanding.predeterminedItemInfo.length > 0) {
      const predeterminedListInfo = this.props.predeterminedLanding.predeterminedItemInfo;
      const predeterminedLabels = this.props.lables;

      return (

        <div>
          <Tagging ref={tagging => this.tagging = tagging} />
          {channel && channel === 'web' ?
            <PredeterminedListsWeb
              {...this.props}
              predeterminedListInfo={predeterminedListInfo}
              onAddListToMyList={this.handleAddListToMyList}
              addPredeterminedItemInfo={addPredeterminedItemInfo}
              labels={predeterminedLabels}
              eventId={this.eventId}
              eventType={this.eventType}
            />
            :
            <PredeterminedListsWap
              {...this.props}
              predeterminedListInfo={predeterminedListInfo}
              onAddListToMyList={this.handleAddListToMyList}
              addPredeterminedItemInfo={addPredeterminedItemInfo}
              labels={predeterminedLabels}
              eventId={this.eventId}
              eventType={this.eventType}
            />}
        </div>

      );
    }
    return null;
  }

}
const mapStateToProps = state => ({
  myData: state,
  predeterminedLanding: (state.predeterminedLists.data && state.predeterminedLists.data.predeterminedLanding) ? state.predeterminedLists.data.predeterminedLanding : null,
  addPredeterminedItemButton: (state.predeterminedLists.data && state.predeterminedLists.data.addPredeterminedItemButton) ? state.predeterminedLists.data.addPredeterminedItemButton : null,

});
const matchDispatchToProps = dispatch => bindActionCreators({
  getpredeterminedLandingPage,
  getaddPredeterminedItem,

}, dispatch);
export default connect(mapStateToProps, matchDispatchToProps)(PredeterminedLists);
